import { Injectable } from '@angular/core';
import { Brand, User } from '../interfaces';
import { CryptoService } from './crypto.service';

declare global {
  interface Window {
    dataLayer: any[];
  }
}
@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor(private readonly cryptoService: CryptoService) {
    window.dataLayer = window.dataLayer || [];
  }

  public sendEvent(
    eventName: string,
    eventCategory: string,
    eventLabel: string | null = null,
    eventValue: number | null = null
  ): void {
    window.dataLayer.push({
      event: eventName,
      event_category: eventCategory,
      event_label: eventLabel,
      value: eventValue,
    });
  }

  public sendCustomEvent<T>(eventName: string, eventValue: T): void {
    window.dataLayer.push({
      event: eventName,
      ...eventValue,
    });
  }

  public sendPageView(url: string): void {
    window.dataLayer.push({
      event: 'page_view',
      page_path: url,
    });
  }

  public sendUserAnalyticsConfig(
    driveCampaign: string,
    workspace: string,
    project: string,
    subsection: string = '',
    section: string = ''
  ): void {
    const brand: Brand = JSON.parse(localStorage.getItem('brand'));
    const auth_user: User = JSON.parse(localStorage.getItem('auth_user'));
    this.cryptoService.hashSHA256(auth_user.username).then((hashedUsername: string) =>
      window.dataLayer.push({
        event: 'user_properties',
        mtm_email: hashedUsername,
        mtm_user_brand: brand?.name,
        mtm_user_company: auth_user.company.name,
        mtm_user_type: auth_user.userPermissionType,
        mtm_drive_campaign: driveCampaign,
        mtm_workspace: workspace,
        mtm_user_name: hashedUsername,
        mtm_project: project,
        mtm_subsection: subsection,
        mtm_section: section,
      })
    );
  }
}
